import { render, staticRenderFns } from "./SentinelOriana.vue?vue&type=template&id=5e459e5f&"
import script from "./SentinelOriana.vue?vue&type=script&lang=js&"
export * from "./SentinelOriana.vue?vue&type=script&lang=js&"
import style0 from "./SentinelOriana.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports